import React, { useContext, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IAdditionalModalContext, AdditionalModalContext } from '../additionalModalState/additionalModalContext';
import { IUpdateDishV2 } from 'types';
import { updateDishV2 } from 'backend/dishes';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { convertUndefinedFields } from 'utils/helpers';
import { Form } from 'antd';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import { AdditionalDishesField } from './AdditionalDishesField';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
}

export const EditForm: React.FC<IProps> = ({ onCloseModal, onFailureEvent, onShowError }) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		setAdditionalDishCategory,
		setAdditionalDishSubCategory,
		setFetchedAdditionalDishes,
		setAdditionalDishes,
		removeAdditionalDish,
		dishInfo,
		IDsSelectedRestaurant,
		selectedAdditionalDishCategory,
		selectedAdditionalDishSubCategory,
		fetchedAdditionalDishes,
		selectedAdditionalDishes,
	} = useContext<IAdditionalModalContext>(AdditionalModalContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			selectedAdditionalDishCategory,
			selectedAdditionalDishSubCategory,
			selectedAdditionalDishes,
		});
	}, [selectedAdditionalDishCategory, selectedAdditionalDishSubCategory, selectedAdditionalDishes]);

	const handleAssignRestaurants = async () => {
		if (dishInfo) {
			try {
				const dataForSubmit: IUpdateDishV2 = {
					id: dishInfo.id,
					fileId: '',
					name: dishInfo.name,
					description: dishInfo.description,
					articleNumber: dishInfo.articleNumber,
					externalId: dishInfo.externalId,
					translations: dishInfo.translations,
					overrideScheduleAvailability: dishInfo.overrideScheduleAvailability,
					activationCron: dishInfo.activationCron,
					deactivationCron: dishInfo.deactivationCron,
					restaurantIds: IDsSelectedRestaurant,
					suggestedDishIds: dishInfo.suggestedDishes.map((suggestedDish) => suggestedDish.id),
					additionalDishIds: selectedAdditionalDishes,
					dishModificationIds: dishInfo.dishModifications.map((dishModification) => dishModification.id),
				};
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateDishV2(convertedData);
				onCloseModal();
			} catch (err) {
				onShowError();
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="editAdditionalList"
			headerTranslationNameSpace="form"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}
			width="60%"
			isDisabledSave={!dishInfo}>
			<Form form={form} name="basic" onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<AdditionalDishesField
					setFetchedAdditionalDishes={setFetchedAdditionalDishes}
					setAdditionalDishCategory={setAdditionalDishCategory}
					setAdditionalDishSubCategory={setAdditionalDishSubCategory}
					setAdditionalDishes={setAdditionalDishes}
					removeAdditionalDish={removeAdditionalDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedAdditionalDishCategory={selectedAdditionalDishCategory}
					selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
					selectedAdditionalDishes={selectedAdditionalDishes}
					fetchedAdditionalDishes={fetchedAdditionalDishes}
				/>
			</Form>
		</ModalContent>
	);
};
